import React from 'react';
import T from 'prop-types';

const Selection = ({ range, pixelsPerSecond }) => {
  const [startPosition, endPosition] = range
    .map(second => second * pixelsPerSecond)
    .sort((a, b) => a - b);
  const width = endPosition - startPosition;

  return (
    <div
      className="editor-timeline__selection"
      style={{ left: `${startPosition}px`, width: `${width}px` }}
    />
  );
};

Selection.propTypes = {
  pixelsPerSecond: T.number.isRequired,
  range: T.arrayOf(T.number).isRequired,
};

export default Selection;
